import { AfterViewInit, Component, inject, Input, signal, WritableSignal } from '@angular/core';
import { Store } from '@ngrx/store';
import { DialogModule } from "primeng/dialog";
import { selectAdminEvent } from '../../../../../data-services/stores/selectors/admin.selectors';
import { CommonModule } from '@angular/common';
import { EventComplete } from '../../../../../data-services/models/events/event-complete.model';
import { AccordionComponent, AccordionPanelComponent } from "../../../../../core/accordion/feature/accordion.component";
import { FileUpload, UploadEvent } from "primeng/fileupload";
import { environment } from '../../../../../../environments/environment';
import { HttpHeaders, HttpResponse } from '@angular/common/http';
import { AuthService } from '../../../../../data-services/auth.service';
import { adminApiActions } from '../../../../../data-services/stores/actions/admin.actions';
import { Observable, of, tap } from 'rxjs';
import { TableModule } from "primeng/table";
import { InputNumberModule } from "primeng/inputnumber";
import { FaIconComponent } from "@fortawesome/angular-fontawesome";
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { SelectModule } from "primeng/select";
import { EditorModule } from 'primeng/editor';
import { RouterModule } from '@angular/router';
import { NewComponent } from "../../tickets/new/feature/new.component";

@Component({
  selector: 'app-admin-event-wizard',
  imports: [DialogModule, CommonModule, AccordionComponent, AccordionPanelComponent, FileUpload, TableModule, InputNumberModule, FaIconComponent, FormsModule, ReactiveFormsModule, SelectModule, EditorModule, RouterModule, NewComponent],
  templateUrl: '../ui/admin-event-wizard.component.html',
  styleUrl: '../ui/admin-event-wizard.component.css',
})
export class AdminEventWizardComponent implements AfterViewInit {
  private readonly _store = inject(Store);
  private readonly _authService = inject(AuthService)
  @Input({required: true}) eventRef!: string | number;
  
  @Input() visible: WritableSignal<boolean> = signal(false);
  currentStep:number = 0;
  eventId?: number;

  lrpEvent$: Observable<EventComplete | undefined> = of();

  catererForm:FormGroup = new FormGroup({
    name: new FormControl<string>('', [Validators.required, Validators.minLength(3)]),
    contact: new FormControl<string>(''),
    display: new FormControl<boolean>(false),
    notes: new FormControl<string>('')
  })

  get apiUrl(): string {
    return `${environment.API}admin/events/${this.eventId}/image`
  }

  get getHeaders(): HttpHeaders {
    const headers: HttpHeaders = new HttpHeaders();
    headers.set('authorization',`Bearer ${this._authService.currentToken}`);
    return headers;
  }

  ngAfterViewInit(): void {
    this.lrpEvent$ = this._store.select(selectAdminEvent(this.eventRef)).pipe(tap(x => 
      {
        this.eventId = x?.eventID
        if (x?.eventsCaterings){
          setTimeout(() => this.currentStep = 3, 200)
        }
        else if ((x?.eventTickets.length ?? 0) > 0){
          setTimeout(() => this.currentStep = 2, 200)
        }
        else if (x?.image){
          setTimeout(() => this.currentStep = 1, 200)
        }

      }))
    this.visible.set(true);
  }

  onUpload(event:UploadEvent) {
    const response = event.originalEvent as HttpResponse<EventComplete>;
    if (response.body){
      this._store.dispatch(adminApiActions.fetchEvent({ event: response.body}))
      setTimeout(() => this.currentStep = 1, 500)
    }
  }

  choose(event, callback) {
    callback();
  }

  checkExists(input:any){
    if (typeof(input) === undefined)
      return signal(false)
    return signal(true)
  }

  convertToSignal(value:boolean){
    return signal(value);
  }
}